/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MachineData } from '../../models/machine-data';

export interface GetStatus$Params {
  workCenterId: number;
}

export function getStatus(http: HttpClient, rootUrl: string, params: GetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<MachineData>> {
  const rb = new RequestBuilder(rootUrl, getStatus.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MachineData>;
    })
  );
}

getStatus.PATH = '/api/v1/Machine/{workCenterId}/GetStatus';
